export function parseWebSocketMessage(rawData, { ignoreSpecial = false } = {}) {
    let payload;
    try {
        payload = JSON.parse(rawData);
    } catch (e) {
        const text = typeof rawData === 'string' ? rawData.trim() : null;
        if (text && (ignoreSpecial || !text.includes('@'))) {
            return { type: 'stream', text };
        }
        return { type: 'ignore' };
    }

    const conversationId = payload?.conversation_id;

    if (payload && payload.type === 'history') {
        if (payload.entryType === 'api') {
            const message = {
                id: crypto.randomUUID?.() ?? Math.random().toString(36).slice(2),
                type: 'api',
                name: payload.name,
                result: payload.result,
                text: payload.string,
                user: 'bot',
                timestamp: new Date().toISOString(),
                endConversation: payload.endConversation === true,
            };
            return { type: 'history_api', message, conversationId };
        }
        const message = {
            id: crypto.randomUUID?.() ?? Math.random().toString(36).slice(2),
            type: 'text',
            text: payload.string,
            user: payload.role === 'user' ? 'user' : 'bot',
            timestamp: new Date().toISOString(),
        };
        return { type: 'history', message, conversationId };
    }

    if (payload && payload.type === 'api') {
        if (payload.replay === true) return { type: 'ignore', conversationId };
        const message = {
            id: crypto.randomUUID?.() ?? Math.random().toString(36).slice(2),
            type: 'api',
            name: payload.name,
            result: payload.result,
            text: payload.string,
            user: 'bot',
            timestamp: new Date().toISOString(),
            endConversation: payload.endConversation === true,
        };
        return { type: 'api', message, conversationId };
    }

    if (payload && payload.type === 'final' && Array.isArray(payload.string)) {
        const entities = {};
        payload.string.forEach(str => {
            const firstSpaceIndex = str.indexOf(' ');
            if (firstSpaceIndex === -1) return;
            let key = str.substring(0, firstSpaceIndex);
            const value = str.substring(firstSpaceIndex + 1);
            if (key.startsWith('@')) key = key.substring(1);
            if (key) entities[key] = value;
        });
        return { type: 'entities', entities, conversationId };
    }

    if (payload && payload.string) {
        let text = null;
        if (Array.isArray(payload.string)) {
            text = payload.string.map(v => String(v).trim()).filter(Boolean).join(' | ');
        } else if (typeof payload.string === 'string') {
            text = payload.string.trim();
        }
        if (text && (ignoreSpecial || (!text.includes('@') && !text.includes('{#')))) {
            return { type: 'stream', text, conversationId, endConversation: payload.endConversation === true };
        }
    }

    return { type: 'ignore' };
}

export function buildSendPayload(message) {
    if (message.type === 'text') {
        return { type: 'text', text: message.text };
    }
    if (message.type === 'image' || message.type === 'file') {
        const base64Content = message.content.split(',')[1];
        return { type: 'file', filename: message.filename, content_b64: base64Content };
    }
    return null;
}
